<template>
    <div class="Report__step">
        <button
            type="button"
            class="Report__step__title"
            @click="toggleExpansion"
        >
            <v-icon
                left
                small
                v-if="expanded"
            >
                fas fa-caret-down
            </v-icon>
            <v-icon
                left
                small
                v-else
            >
                fas fa-caret-right
            </v-icon>
            {{ step.name }}
        </button>

        <div
            v-if="step.sections && expanded"
            class="Report__sections"
        >
            <ReportSection
                v-for="(section, index) in step.sections"
                :key="index"
                :section="section"
                :step="step"
            />
        </div>
    </div>
</template>

<script>
import ReportSection from '@/reports/ReportSection';
export default {
    components: { ReportSection },
    props: {
        step: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            expanded: true
        };
    },

    mounted() {
        const exp = localStorage.getItem(`reportStep${this.step.name}expanded`);
        if (exp === 'false') {
            this.expanded = false;
        }
    },

    methods: {
        toggleExpansion() {
            this.expanded = !this.expanded;
            localStorage.setItem(`reportStep${this.step.name}expanded`, this.expanded ? 'true' : 'false');
        }
    }
};
</script>

<style lang="scss">
.Report__step {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;

    button {
       outline: none !important;
    }
}

.Report__step__title {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;
    font-size: 1.5rem;
    font-weight: 900;
}

.Report__sections {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
}

</style>
